import { User } from "store/environments/tenants/users/users-types";
import { Tenant } from "store/environments/environment-types";

import { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

export const loadUsers = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[Tenant<ReadonlyArray<User>> | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.get(
        `/environments/${environmentId}/tenants/${tenantId}/users`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const validateIntegrationUser = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[boolean | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.post(
        `/environments/${environmentId}/tenants/${tenantId}/users/integration/validate`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const disableIntegrationUserDomainValidation = async (
    environmentId: string,
    tenantId: string
): Promise<[null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.post(
        `/environments/${environmentId}/tenants/${tenantId}/users/users/integration/domain-validation/disable`
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
